<form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
  <div class="flex-item d-md-flex justify-content-end align-items-center">
    <div class="d-md-flex flex-fill justify-content-end">
      <div class="filter-search-box flex-item form-group ml-md-2">
        <div class="search-box position-relative">
          <input
            type="text"
            formControlName="searchCriteria"
            data-id="searchCriteria"
            class="searchCriteria form-control"
            placeholder="{{ 'CJ_PRODUCT.ENTER_KEY_PLACEHOLDER' | translate }}"
            required
            maxlength="50"
            (keyup.backspace)="clearLastKeyUpSearchText($event)"
          />
          <em
            class="icon-close-mini"
            [ngClass]="{ 'd-none': !searchForm.controls['searchCriteria'].value }"
            data-id="clearSearchCriteria"
            (click)="clearSearchText()"
          ></em>
          <button class="btn-search" type="submit" data-id="btnSubmitSearch">
            <em class="icon-search"></em>
          </button>
        </div>
      </div>
      <div class="filter-dropdown flex-item form-group ml-md-2">
        <ng-select
          [items]="storeRequestStatusFilter"
          [searchable]="false"
          [clearable]="false"
          bindLabel="label"
          bindValue="value"
          formControlName="status"
          (change)="onchangeStatus($event)"
        >
        </ng-select>
      </div>
      <div class="text-nowrap form-group ml-md-2 d-none d-lg-block">
        <button
          data-id="btnAdvanceFilter"
          class="btn advance-filter-button btn-advance-filter"
          [ngClass]="{ active: isShowAdvanceSearch }"
          type="button"
          (click)="isShowAdvanceSearch = !isShowAdvanceSearch"
        >
          <em class="icon-filter"></em>
          {{ 'ADVANCED_FILTERS' | translate }}
        </button>
        <div
          class="box-dropdown"
          [ngClass]="{ open: isShowAdvanceSearch }"
          (appClickOutside)="onClickedOutside($event)"
          [exclude]="['.btn-advance-filter', '.is-highlighted']"
        >
          <div class="box-dropdown-list advance-filter-dropdown">
            <div class="box-dropdown-body px-4">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-2">Requested Date</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ 'FROM' | translate }}</label>
                      <input
                        data-id="startRequestDate"
                        id="startRequestDate"
                        formControlName="startRequestDate"
                        type="text"
                        placeholder="{{ dateFormat }}"
                        autocomplete="off"
                        class="form-control calendar"
                        bsDatepicker
                        [bsConfig]="bsDateConfig"
                        [maxDate]="maxDate"
                        (bsValueChange)="onChangeDateFrom($event)"
                        readonly
                      />
                      <label for="startRequestDate" class="icon-calendar btn-calendar"></label>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ 'TO' | translate }}</label>
                      <input
                        data-id="endRequestDate"
                        id="endRequestDate"
                        formControlName="endRequestDate"
                        type="text"
                        placeholder="{{ dateFormat }}"
                        autocomplete="off"
                        class="form-control calendar"
                        bsDatepicker
                        [bsConfig]="bsDateConfig"
                        [minDate]="minDate"
                        (bsValueChange)="onChangeDateTo($event)"
                        readonly
                      />
                      <label for="endRequestDate" class="icon-calendar btn-calendar"></label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="mb-2">
                        {{ 'CJ_PRODUCT.REQUEST_TYPE' | translate }}
                      </div>
                      <ng-select
                        placeholder="Please select..."
                        [items]="storeRequestTypeFilter"
                        [searchable]="false"
                        [clearable]="true"
                        [multiple]="true"
                        bindLabel="label"
                        bindValue="value"
                        formControlName="type"
                        class="clear-cycle"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="advance-filter-footer text-center">
              <button
                class="btn btn-standard mr-2"
                data-id="btnCancelAdvanceFilter"
                type="button"
                (click)="onClickedOutside($event)"
              >
                Cancel
              </button>
              <button
                class="btn btn-primary"
                type="button"
                data-id="btnSubmitAdvanceFilter"
                (click)="onAdvanceSubmit()"
              >
                {{ 'APPLY' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="top-search-criteria space-search-criteria" *ngIf="dateStringTag || typeStringTag">
  <div class="search-criteria" *ngIf="dateStringTag">
    <a class="remove-criteria" data-id="clearDateTag" (click)="clearFilterDate()">
      <em class="icon-close"></em>
    </a>
    <span>{{ dateStringTag }}: {{ dateTag }}</span>
  </div>

  <div class="search-criteria" *ngIf="typeStringTag">
    <a class="remove-criteria" data-id="clearTypeTag" (click)="clearFilterType()">
      <em class="icon-close"></em>
    </a>
    <span>{{ typeStringTag }}: {{ typeTag }}</span>
  </div>

  <div class="d-inline-block">
    <a class="btn clear-btn" data-id="clearAllTag" (click)="clearAdvanceFilter()">Clear All</a>
  </div>
</div>

<ng-container *ngIf="(listState$ | async).totalElements > 0">
  <div class="table-responsive">
    <table id="data-table" class="table table-striped table-bordered table-hover w-100" aria-label="data-table">
      <thead>
        <tr>
          <th class="text-center w-15" scope="col">Request No.</th>
          <th class="text-center w-10" scope="col">Store Code</th>
          <th class="text-center w-10" scope="col">Store Name</th>
          <th class="text-center w-10" scope="col">Merchant ID</th>
          <th class="text-center w-10" scope="col">Request Type</th>
          <th class="text-center w-15" scope="col">Requested By</th>
          <th class="text-center w-10" scope="col">Requested Date</th>
          <th class="text-center w-10" scope="col">Status</th>
          <th class="text-center w-5" scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of resultList$ | async; index as i">
          <td class="text-left" (click)="goToView(result)">
            {{ getRequestNo(result) }}
          </td>
          <td class="text-left" (click)="goToView(result)">
            {{ result.storeCode | dashDisplay: '(None)' }}
          </td>
          <td class="text-left" (click)="goToView(result)">
            {{ result.storeName | dashDisplay: '(None)' }}
          </td>
          <td class="text-left" (click)="goToView(result)">
            {{ result.merchantNo | dashDisplay: '(None)' }}
          </td>
          <td (click)="goToView(result)">
            {{ 'STORE_REQUEST.TYPE.' + (result.type || 'N') | translate }}
          </td>
          <td class="text-left" (click)="goToView(result)">
            {{ result.requestBy | dashDisplay }}
          </td>
          <td class="text-center" (click)="goToView(result)">
            {{ result.requestedDate | amFromUtc | amLocal | dateDisplay }}
          </td>
          <td (click)="goToView(result)" class="request-status" [ngClass]="getColorStatus(result.requestStatus)">
            {{ 'STORE_REQUEST.STATUS.' + result.requestStatus | translate }}
          </td>

          <td class="text-center">
            <a
              href="javascript:void(0)"
              class="btn-more mx-auto"
              [popover]="moreTemplate"
              placement="bottom right"
              [adaptivePosition]="false"
              [outsideClick]="true"
              *ngIf="
                hasEditPermission(result.type, result.step, result.requestStatus) ||
                (result.requestStatus === 'D' &&
                  hasDeletePermission(result.type, result.step, result.requestStatus)) ||
                hasCancelPermission(result.requestStatus) ||
                (result.requestStatus !== 'D' && hasViewHistoryPermission(result.requestStatus))
              "
            >
              <em class="icon-more"></em>
            </a>
            <ng-template #moreTemplate>
              <button
                type="button"
                data-id="btnGoToEdit"
                class="btn btn-link"
                *ngIf="hasEditPermission(result.type, result.step, result.requestStatus)"
                (click)="goToEdit(result)"
              >
                <em class="icon-edit"></em>Edit
              </button>
              <button
                type="button"
                data-id="btnDeleteStoreRequest"
                class="btn btn-link"
                *ngIf="
                  result.requestStatus === 'D' && hasDeletePermission(result.type, result.step, result.requestStatus)
                "
                (click)="deleteStoreRequest(result.id)"
              >
                <em class="icon-delete"></em>Delete
              </button>
              <button
                type="button"
                class="btn btn-link"
                data-id="btnCancelStoreRequest"
                *ngIf="hasCancelPermission(result.requestStatus)"
                (click)="cancelStoreRequest(result.step, result.requestNo)"
              >
                <em class="icon-forbidden"></em>Cancel Request
              </button>
              <button
                type="button"
                class="btn btn-link"
                data-id="btnViewHistory"
                *ngIf="result.requestStatus !== 'D' && hasViewHistoryPermission(result.requestStatus)"
                (click)="showHistory(result.id, result.requestNo)"
              >
                <em class="icon-history"></em>History
              </button>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!--pagination-->
  <app-search-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [listState$]="listState$"
    (changePage)="onChangePage($event)"
    (changeRowPerPage)="onChangeRowPerPage($event)"
  >
  </app-search-pagination>
</ng-container>

<app-no-search-result [resultList$]="listState$" [hasSearchCriteria]="hasSearchCriteria"></app-no-search-result>
